import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './table__row-number.scss';

const TableRowNumber = ({ mix }) => {
    return <div className={cx('table__row-number', mix)} />;
};

TableRowNumber.propTypes = {
    mix: PropTypes.string,
};

export default TableRowNumber;
